<nz-layout>
  <nz-header
    nz-row
    nzAlign="middle"
    nzJustify="space-between"
    >
    <div nz-col nzFlex="initial">
      <div nz-row [nzGutter]="5" nzAlign="middle">
        <div nz-col>
          <beautyapp-datepicker
            [(ngModel)]="currentDate"
            (ngModelChange)="changeDate($event)"
            [allowClear]="false"
          ></beautyapp-datepicker>
        </div>
        <div nz-col>
          <nz-space-compact>
            <button nz-button nzType="default" (click)="shiftDay(-1)">
              <i nz-icon nzType="left" nzTheme="outline"></i>
            </button>
            <button nz-button nzType="default" (click)="today()">
              <i nz-icon nzType="carry-out" nzTheme="outline"></i>
            </button>
            <button nz-button nzType="default" (click)="shiftDay(1)">
              <i nz-icon nzType="right" nzTheme="outline"></i>
            </button>
          </nz-space-compact>
        </div>
      </div>
    </div>
    <div nz-col nzFlex="initial"></div>
  <div nz-col nzFlex="auto"></div>
  <div nz-col nzFlex="initial">
    <nz-space>
      <nz-space-compact *nzSpaceItem>
        <button
          nz-button
          [nzType]="slotMinutes() === 5 ? 'primary' : 'default'"
          (click)="updateSlotMinutes(5)"
          >
          5 {{ 'calendar.minute' | translate }}.
        </button>
        <button
          nz-button
          [nzType]="slotMinutes() === 15 ? 'primary' : 'default'"
          (click)="updateSlotMinutes(15)"
          >
          15 {{ 'calendar.minute' | translate }}.
        </button>
        <button
          nz-button
          [nzType]="slotMinutes() === 20 ? 'primary' : 'default'"
          (click)="updateSlotMinutes(20)"
          >
          20 {{ 'calendar.minute' | translate }}.
        </button>
        <button
          nz-button
          [nzType]="slotMinutes() === 30 ? 'primary' : 'default'"
          (click)="updateSlotMinutes(30)"
          >
          30 {{ 'calendar.minute' | translate }}.
        </button>
        <button
          nz-button
          [nzType]="slotMinutes() === 60 ? 'primary' : 'default'"
          (click)="updateSlotMinutes(60)"
          >
          1{{ 'calendar.hours' | translate }}.
        </button>
      </nz-space-compact>
    </nz-space>

  </div>

  <div nz-col nzFlex="initial">
    <nz-space>
      @if (viewMode() === 'horizontal') {
        <button
          *nzSpaceItem
          nz-button
          nzType="default"
          nzShape="circle"
          (click)="changeView('vertical')"
          >
          <i nz-icon nzType="insert-row-above" nzTheme="outline"></i>
        </button>
      }
      @if (viewMode() === 'vertical') {
        <button
          *nzSpaceItem
          nz-button
          nzType="default"
          nzShape="circle"
          (click)="changeView('horizontal')"
          >
          <i nz-icon nzType="insert-row-left" nzTheme="outline"></i>
        </button>
      }
      <button
        *nzSpaceItem
        nz-button
        nzType="default"
        nzShape="circle"
        (click)="orderResources()"
        >
        <i nz-icon nzType="team" nzTheme="outline"></i>
      </button>
    </nz-space>
  </div>
</nz-header>
<nz-content>
  <div class="demo-container">
    <beautyapp-scheduler
      [resources]="resources()"
      [events]="events()"
      [start]="start()"
      [end]="end()"
      [slotMinutes]="slotMinutes()"
      [viewMode]="viewMode()"
      [config]="{ dragDrop: true, resize: true }"
      [offLabel]="'calendar.notWorking' | translate"
      (eventClick)="onEventClick($event)"
      (slotClick)="onSlotClick($event)"
      (slotContextMenu)="onSlotContextMenu($event)"
      (eventDrop)="onEventDrop($event)"
      (eventResize)="onEventResize($event)"
      >
      <!-- custom resource card template -->
      <ng-template beautyappSchedulerResource let-resource>
        <div class="res-card">
          <div class="name">{{ resource.title }}</div>
          <nz-space>
            <!--
              beaut-556: gated on the PERMISSION, not on two hard-coded role
              names. This is the employee's takings for the day — the figure the
              retired `calendar.employee_salary_view` key was created for, and
              the basis of a percentage-paid employee's salary.

              With role names an `Administrator` saw nothing here, however the
              salon had configured them, because the list says Admin and
              Manager and there is no third name in it. That was half of the
              reported bug: the `50%` tags were missing for a different reason
              (the permission was filed under another spelling), and this
              number was missing for this one.
            -->
            <ng-template [ngxPermissionsOnly]="['field.employee_salary']">
              @let totalPrice = resourceTotalPrices()[resource.id];
              @if (totalPrice > 0) {
                <div *nzSpaceItem
                  class="flex justify-center items-center py-1 px-2 bg-white border border-gray-200 rounded-2xl"
                  >
                  {{ totalPrice || 0 }} GEL
                </div>
              }
            </ng-template>
            <button
              *nzSpaceItem
              nz-button
              nzType="text"
              nzSize="small"
                [routerLink]="[
                  '/calendars/day/forEmployee',
                  resource.userId
                ]"
              >
              <span
                [nzTooltipTitle]="'calendar.tooltip.calendar' | translate"
                nz-tooltip
                nz-icon
                nzType="calendar"
                nzTheme="outline"
              ></span>
            </button>
            <button *nzSpaceItem nz-button nzType="text" nzSize="small"
              [nzTooltipTitle]="'calendar.tooltip.employeeCard' | translate" nz-tooltip
              (click)="employeeCard(resource)">
              <span
                nz-icon
                nzType="user"
                nzTheme="outline"
              ></span>
            </button>
          </nz-space>
        </div>
      </ng-template>

      <!-- custom event card template -->
      <ng-template beautyappSchedulerEvent let-event let-resource="resource" let-viewMode="viewMode">
        <div class="ev-card" [style.opacity]="event?.extendedProps?.isAdditionalEmployee ? '0.7' : '1'" [style.border-left]="event?.extendedProps?.isAdditionalEmployee ? '3px dashed #fff' : ''">
          <div class="flex gap-1">
            @if (event?.extendedProps?.onlineSource?.startsWith('bookinghub')) {
              <img
                src="assets/images/bookinghub-logo.png"
                class="source-logo"
                alt="BookingHub"
                nz-tooltip
                nzTooltipTitle="BookingHub"
              />
            }
            @if (event?.extendedProps?.isHold) {
              <span
                nz-icon
                nzType="lock"
                nzTheme="outline"
                [nzTooltipTitle]="'calendar.hold.tooltip' | translate"
                nz-tooltip
              ></span>
            }
            @if (event?.extendedProps?.isAdditionalEmployee) {
              <span
                nz-icon
                nzType="team"
                nzTheme="outline"
                [nzTooltipTitle]="'calendar.popup.additionalEmployee' | translate"
                nz-tooltip
              ></span>
            }
            @if (event?.extendedProps?.roomName) {
              <span
                nz-icon
                nzType="home"
                nzTheme="outline"
                [nzTooltipTitle]="event?.extendedProps?.roomName"
                nz-tooltip
              ></span>
            }
            @if (event?.extendedProps.visitStatus) {
              @switch (event.extendedProps.visitStatus) {
                @case ('CONFIRMED') {
                  <span nz-icon nzType="check-circle" nzTheme="outline" style="color: #52c41a;" [nzTooltipTitle]="'calendar.status.confirmed' | translate" nz-tooltip></span>
                }
                @case ('IN_PROGRESS') {
                  <span nz-icon nzType="clock-circle" nzTheme="outline" style="color: #1890ff;" [nzTooltipTitle]="'calendar.status.inProgress' | translate" nz-tooltip></span>
                }
                @case ('COMPLETED') {
                  <span nz-icon nzType="lock" nzTheme="fill" style="color: #52c41a;" [nzTooltipTitle]="'calendar.status.completed' | translate" nz-tooltip></span>
                }
                @case ('NO_SHOW') {
                  <span nz-icon nzType="user-delete" nzTheme="outline" style="color: #faad14;" [nzTooltipTitle]="'calendar.status.noShow' | translate" nz-tooltip></span>
                }
                @case ('NEED_CALL') {
                  <span nz-icon nzType="phone" nzTheme="outline" style="color: #eb2f96;" nz-tooltip="დასარეკია"></span>
                }
              }
            } @else if (event?.extendedProps.status === 2) {
              <span nz-icon nzType="lock" nzTheme="fill"></span>
            }
            @if (event?.extendedProps?.onUserRequest) {
              <svg  width="12" height="12" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" viewBox="0 0 501.986 501.986" xml:space="preserve" fill="#000000"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <g> <path style="fill:#FBB03B;" d="M287.442,42.472l42.984,87.096c5.921,11.997,17.365,20.312,30.604,22.235l96.116,13.966 c33.339,4.844,46.651,45.815,22.527,69.331l-69.55,67.795c-9.58,9.338-13.951,22.792-11.69,35.978l16.419,95.728 c5.695,33.204-29.157,58.526-58.976,42.849l-85.969-45.196c-11.841-6.225-25.988-6.225-37.829,0l-85.969,45.196 c-29.819,15.677-64.671-9.644-58.976-42.849l16.419-95.728c2.261-13.185-2.11-26.639-11.69-35.978L22.312,235.1 C-1.812,211.585,11.5,170.614,44.839,165.77l96.116-13.966c13.239-1.924,24.684-10.239,30.604-22.235l42.984-87.096 C229.454,12.262,272.533,12.262,287.442,42.472z"></path> <path d="M374.839,492.172c-8.05,0-16.139-1.941-23.616-5.872l-85.969-45.196c-8.931-4.694-19.593-4.693-28.521,0L150.764,486.3 c-17.189,9.037-37.628,7.56-53.338-3.855C81.715,471.03,73.995,452.05,77.277,432.91l16.419-95.728 c1.705-9.944-1.59-20.084-8.813-27.126l-69.551-67.794C1.426,228.707-3.484,208.813,2.517,190.343 c6-18.469,21.667-31.677,40.885-34.469l96.115-13.967c9.984-1.451,18.61-7.718,23.075-16.765l42.984-87.096 c8.595-17.414,25.998-28.232,45.417-28.232s36.822,10.818,45.417,28.232l0,0l42.984,87.096 c4.465,9.047,13.091,15.314,23.075,16.765l96.115,13.967c19.218,2.792,34.885,16,40.885,34.469 c6.001,18.469,1.091,38.363-12.815,51.918l-69.55,67.794c-7.225,7.042-10.52,17.183-8.814,27.127l16.419,95.727 c3.282,19.14-4.438,38.121-20.148,49.535C395.685,488.895,385.295,492.172,374.839,492.172z M250.993,417.582 c8.096,0,16.188,1.939,23.567,5.819l85.969,45.196c10.559,5.551,22.625,4.679,32.275-2.333s14.208-18.217,12.191-29.974 l-16.419-95.728c-2.817-16.434,2.628-33.192,14.567-44.829l69.549-67.794c8.543-8.327,11.442-20.071,7.756-31.417 c-3.687-11.345-12.935-19.142-24.739-20.857l-96.117-13.967c-16.499-2.397-30.754-12.755-38.134-27.706l-42.984-87.096 c-5.279-10.697-15.553-17.083-27.481-17.083c-11.929,0-22.202,6.386-27.481,17.083l-42.984,87.096 c-7.38,14.951-21.635,25.308-38.134,27.706l-96.116,13.967c-11.806,1.715-21.054,9.513-24.74,20.857 c-3.687,11.345-0.787,23.09,7.756,31.416l69.55,67.794c11.938,11.637,17.384,28.396,14.566,44.829L96.99,436.291 c-2.017,11.757,2.541,22.962,12.191,29.974c9.651,7.012,21.717,7.884,32.275,2.333l85.969-45.196 C234.804,419.522,242.899,417.582,250.993,417.582z"></path> </g> <g> <path d="M231.978,103.014c-1.486,0-2.994-0.333-4.418-1.035c-4.952-2.444-6.985-8.44-4.542-13.393l8.559-17.342 c2.444-4.953,8.438-6.988,13.394-4.542c4.952,2.444,6.985,8.44,4.542,13.393l-8.559,17.342 C239.211,100.966,235.664,103.014,231.978,103.014z"></path> </g> <g> <path d="M145.668,198.093c-4.887,0-9.16-3.585-9.884-8.563c-0.794-5.465,2.993-10.54,8.458-11.334 c23.306-3.387,43.441-18.017,53.863-39.134l9.612-19.476c2.443-4.953,8.44-6.986,13.394-4.542 c4.952,2.444,6.985,8.44,4.542,13.393l-9.612,19.476c-13.337,27.021-39.102,45.741-68.922,50.075 C146.632,198.059,146.147,198.093,145.668,198.093z"></path> </g> </g> </g></svg>
            }
            <span>
              <span class="title">{{ event?.title }}
              {{ event?.extendedProps?.mobilePhone }}</span>

            </span>
          </div>

          <div class="time">{{ event.start | date:'shortTime' }}-{{ event.end | date:'shortTime' }}</div>
        </div>
      </ng-template>

      <!-- custom popover template for events -->
      <ng-template beautyappSchedulerEventPopover let-event let-resource="resource" let-viewMode="viewMode">
        <div class="booking-popup">
          @if (event.extendedProps?.isAdditionalEmployee) {
            <div style="color: #1890ff; font-weight: bold; margin-bottom: 4px;">
              <span nz-icon nzType="team" nzTheme="outline"></span> {{ 'calendar.popup.additionalEmployee' | translate }}
            </div>
          }
          <div><b>{{ 'calendar.popup.employee' | translate }}:</b> {{ event.extendedProps.employeeName }}</div>
          @if (event.extendedProps?.additionalEmployees?.length) {
            <div><b>{{ 'calendar.popup.additionalEmployee' | translate }}:</b> {{ event.extendedProps.additionalEmployees.join(', ') }}</div>
          }
          @if (event.extendedProps?.roomName) {
            <div><b>{{ 'calendar.popup.room' | translate }}:</b> {{ event.extendedProps.roomName }}</div>
          }
          @if (event.extendedProps.anonymousName || event.extendedProps.fullName) {
            <div><b>{{ 'calendar.popup.user' | translate }}:</b> {{ event.extendedProps.isAnonymous ? event.extendedProps.anonymousName : event.extendedProps.fullName }}</div>
          }
          @if (event.extendedProps.mobilePhone){
            <div><b>{{ 'calendar.popup.mobilePhone' | translate }}:</b> {{ event.extendedProps.mobilePhone }}
          </div>
        }
        @if (event.extendedProps.balance) {
          <div><b>{{ 'calendar.popup.balance' | translate }}:</b> {{ event.extendedProps.balance }} GEL</div>
        }
        @if (event.extendedProps.services) {
          <div><b>{{ 'calendar.popup.procedure' | translate }}:</b> {{ event.extendedProps.services ? event.extendedProps.services : 'N/A' }}</div>

        }
        @if (event.extendedProps.price) {
          @if (event.extendedProps.salePrice) {
            <div><b>{{ 'calendar.popup.price' | translate }}:</b> <del>{{ event.extendedProps.price }} GEL</del></div>
          } @else {
            <div><b>{{ 'calendar.popup.price' | translate }}:</b> {{ event.extendedProps.price }} GEL</div>
          }
        }
        @if (event.extendedProps.salePrice) {
          <div><b>{{ 'calendar.popup.discount' | translate }}:</b> {{ event.extendedProps.salePrice }} GEL</div>
        }

        @if (event.extendedProps.visitStatus) {
          <div><b>{{ 'calendar.popup.status' | translate }}:</b> {{ event.extendedProps.visitStatus | visitStatus }}</div>
        }
        <div><b>{{ 'calendar.popup.times' | translate }}
        :</b> {{ (event.start | date : 'HH:mm') + ' - ' + (event.end | date : 'HH:mm') }}
      </div>
      @if (event.extendedProps.description) {
        <div><b>{{ 'calendar.popup.comment' | translate }}
        :</b> {{ event.extendedProps.description }}
      </div>
    }
    @if (event.extendedProps.createdAt) {
      <div><b>{{ 'calendar.popup.bookedAt' | translate }}
      :</b> {{ event.extendedProps.createdAt | date: 'dd/MM/yyyy HH:mm' }}
    </div>
  }
  @if (event.extendedProps.createdBy) {
    <div><b>{{ 'calendar.popup.bookedBy' | translate }}:</b> {{ event.extendedProps.createdBy }}</div>

  }

  @if (event.extendedProps.completedBy) {
    @if (event.extendedProps.completedBy) {
      <div><b>{{ 'calendar.popup.completedBy' | translate }}
      :</b> {{ event.extendedProps.completedBy }}
    </div>
  }
}

</div>
</ng-template>
</beautyapp-scheduler>
</div>
</nz-content>
</nz-layout>

<!-- Right-click quick-actions menu for empty time slots -->
<nz-dropdown-menu #slotMenu="nzDropdownMenu">
  <ul nz-menu>
    @if (visitBookingEnabled()) {
      <li nz-menu-item (click)="ctxNewVisit()">
        <span nz-icon nzType="plus" nzTheme="outline"></span>
        {{ 'calendar.menu.newVisit' | translate }}
      </li>
    }
    <li nz-menu-item (click)="ctxGoToEmployeeDay()">
      <span nz-icon nzType="calendar" nzTheme="outline"></span>
      {{ 'calendar.menu.employeeDay' | translate }}
    </li>
    <li nz-menu-divider></li>
    <li nz-menu-item nzDanger (click)="ctxBlockTime()">
      <span nz-icon nzType="stop" nzTheme="outline"></span>
      {{ 'calendar.menu.block' | translate }}
    </li>
  </ul>
</nz-dropdown-menu>
